(function ($, Drupal) {
  Drupal.behaviors.megaMenu = {
    attach: function (context, settings) {
  
      $('.menu-bot', context).once('mega-menu-init').hide();
      
      $('.menu-top-item.expandable', context).once('mega-menu').on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        
        var menuIndex = $(this).data('menu-index');
        var targetMenu = $('#menu-bot-' + menuIndex);
        var wasActive = $(this).hasClass('active');
        
        $('.menu-top-item.expandable').removeClass('active');
        $('.menu-bot').hide();
        $('.menu-caret').removeClass('rotated');
        $('li.expandable').removeClass('active'); 

        if (!wasActive) {
          $(this).addClass('active');
          $(this).find('.menu-caret').addClass('rotated');
          targetMenu.show();
          $(this).find('.menu-bot-hr').addClass('active');
        }
      });

      $('.header__search', context).once('mega-menu-search').on('click', function(e) {
        $('.menu-top-item.expandable').removeClass('active');
        $('.menu-bot').hide();
        $('.menu-caret').removeClass('rotated');
        $('li.expandable').removeClass('active');
      });

      $('.menu-bot', context).once('mega-menu-bot').on('click', function(e) {
        e.stopPropagation(); 
      });

      $(document).on('click', function (e) {
        if (!$(e.target).closest('.menu').length) {
          $('.menu-top-item.expandable').removeClass('active');
          $('.menu-bot').hide();
          $('.menu-caret').removeClass('rotated');
          $('li.expandable').removeClass('active');  
        }
      });

      $('.menu-top-item.expandable', context).on('keydown', function (e) {
        if (e.keyCode === 13 || e.keyCode === 32) {
          e.preventDefault();
          $(this).trigger('click');
        }
      }).attr('tabindex', '0');
    }
  };
})(jQuery, Drupal);